export default __webpack_public_path__ + "static/media/applied-learning.10cc8695.png";